import { useContext, useEffect } from 'react';
import { LightboxContext } from '../widgets/LightboxWrapper';

export interface useLightboxDisplayOptions {
  forwardRef: React.RefObject<HTMLDivElement>;
}

export const useLightboxDisplay = (props: useLightboxDisplayOptions) => {
  const context = useContext(LightboxContext);

  useEffect(() => {
    const container = props.forwardRef.current;
    if (!container) {
      return;
    }

    const click = (event: MouseEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const image = target.closest('img');
      if (!image || !container.contains(image) || image.closest('a[href], button')) {
        return;
      }

      context.setImage(image.src);
    };

    container.addEventListener('click', click);
    return () => {
      container.removeEventListener('click', click);
    };
  }, [context, props.forwardRef]);
};
